import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ToolCallResearchIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;

  return (
    <SimpleIcon {...rest} stroke={stroke} viewBoxDimensions="0 0 24 24">
      <path
        d="M23.251 12a3 3 0 0 0 -2.183 -2.886 2.249 2.249 0 0 0 -1.383 -3.856 2.262 2.262 0 0 0 -0.412 -0.363 3 3 0 0 0 -5.46 -2.478 2.25 2.25 0 0 0 -3.625 0 3 3 0 0 0 -5.46 2.478 2.223 2.223 0 0 0 -0.411 0.363 2.25 2.25 0 0 0 -1.384 3.856 3 3 0 0 0 0 5.773 2.249 2.249 0 0 0 1.384 3.855 2.29 2.29 0 0 0 0.411 0.363 3 3 0 0 0 5.46 2.478 2.25 2.25 0 0 0 3.625 0 3 3 0 0 0 5.46 -2.478 2.223 2.223 0 0 0 0.411 -0.363 2.248 2.248 0 0 0 1.384 -3.855A3 3 0 0 0 23.251 12Z"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m13.5 5.25 -5.91 6.882a0.375 0.375 0 0 0 0.286 0.618H10.5v6l5.91 -6.882a0.375 0.375 0 0 0 -0.285 -0.618H13.5Z"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
